import { gql } from "@apollo/client";

export const SEASON_PLAYER_LEADERBOARDS = gql`
    query SeasonPlayerLeaderboards($seasonId: Int!, $sportKey: String!, $stageId: Int, $limit: Int) {
        seasonPlayerLeaderboards(seasonId: $seasonId, sportKey: $sportKey, stageId: $stageId, limit: $limit) {
            key
            rows {
                value
                player { id fullName logoUrl }
                team { id name logoUrl }
            }
        }
    }
`;
